import React, { useState } from 'react';
import { Button, Card, Flex, Text, Box, Heading } from 'rebass';
import styled from 'styled-components';
import ConfirmModal from '../components/ConfirmModal';
import { Mutation, Query } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import gql from 'graphql-tag';
import PleaseWait from '../components/PleaseWait';
import moment from 'moment';

export const ADMIN_OTP_VALIDITY_LIST = gql`
  query adminGetOtpValidities {
    adminGetOtpValidities {
      type
      id
      email
      validUntil
      createdAt
      updatedAt
    }
  }
`;

export const ADMIN_OTP_VALIDITY_REVOKE = gql`
  mutation adminRevokeOtpValidity($id: String!, $type: String!) {
    adminRevokeOtpValidity(id: $id, type: $type)
  }
`;

const ModalInner = styled(Box)`
  max-width: 600px;
  min-width: 1024px;
  max-height: 95vh;
  width: 100%;
  overflow-y: auto;
`;
const ModalInnerSmall = styled(Box)`
  max-width: 600px;
  min-width: 600px;
  max-height: 95vh;
  width: 100%;
  overflow-y: auto;
`;
const Container = styled(Flex)`
  width: 100%;
  height: 100%;
  max-width: 1024px;
  min-width: 1024px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  display: block;
  margin: 0 auto;
  padding: 24px;
`;

const AdminOtpValidities = ({ history }) => {
  const [toDelete, setToDelete] = useState(null);

  return (
    <Container>
      <Card flex={1} style={{ padding: '24px', borderRadius: '24px' }}>
        <Query query={ADMIN_OTP_VALIDITY_LIST}>
          {({ data, loading, error, refetch }) => {
            if (!!loading)
              return (
                <>
                  <Flex mb={4}>
                    <Heading flex={1}>OTP Validities</Heading>
                  </Flex>
                  <PleaseWait text={' '} />
                </>
              );
            return (
              <>
                <Flex>
                  <Flex mb={4} alignItems={'center'}>
                    <Heading flex={1}>OTP Validities</Heading>

                    <Button variant={'outline'} ml={3} p="2px 12px" style={{ height: 'fit-content', paddingTop: '2px', paddingBottom:'2px', width:'fit-content', fontWeight:200, fontSize:'12px' }} onClick={() => refetch()}>
                      Refetch
                    </Button>
                  </Flex>
                </Flex>
                {(data.adminGetOtpValidities || []).map((x) => {
                  return (
                    <Box flex={1} style={{ borderBottom: '1px solid black', cursor: 'pointer', justifyContent: 'center' }} p={3} key={x.id}>
                      <Flex>
                        <Flex flex={1} justifyContent={'center'} alignItems={'center'}>
                          <Text style={{ opacity: 1 }} mr={3}>
                            {x.email}
                          </Text>
                          <Text style={{ opacity: 1, fontWeight: 300, fontSize: 14 }} mr={3}>
                            {moment(x.validUntil).format('MM/DD/YYYY hh:mma z')}
                          </Text>
                          <Flex flex={1} flexWrap={'wrap'} ml={3}>
                            <Box
                              p={'2px 6px'}
                              fontSize={'13px'}
                              backgroundColor={'#fbfbfb'}
                              style={{
                                border: `1px solid ${x.type === 'Admin' ? 'orange' : x.type === 'HealthCoach' ? '#344f79' : '#287602'}`,
                                background: x.type === 'Admin' ? '#ff8f32' : x.type === 'HealthCoach' ? '#337ab7' : '#8dc572',
                                borderRadius: '4px',
                                color: 'white',
                                height: 'fit-content',
                                width: 'fit-content',
                              }}
                              mr={2}
                            >
                              {x.type}
                            </Box>
                          </Flex>
                        </Flex>

                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setToDelete(x);
                          }}
                        >
                          <path d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z" fill="#555" />
                        </svg>
                      </Flex>
                    </Box>
                  );
                })}
              </>
            );
          }}
        </Query>
      </Card>

      {!!toDelete && (
        <ConfirmModal
          childrenManaged
          isOpen={!!toDelete}
          okOnly
          onClose={() => {}}
          onConfirm={() => {}}
          onBackgroundClick={() => {
            setToDelete(null);
          }}
          onEscapeKeydown={() => {
            setToDelete(null);
          }}
        >
          <ModalInnerSmall id="mi">
            <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
              <Heading>Warning</Heading>

              <Text mt={4} mb={4}>
                Are you sure to want to revoke the following OTP validity? <span style={{ color: 'red' }}>(the user will have to enter an OTP next time they log in)</span>
              </Text>
              <Mutation
                mutation={ADMIN_OTP_VALIDITY_REVOKE}
                variables={{
                  id: toDelete.id,
                  type: toDelete.type,
                }}
                refetchQueries={[{ query: ADMIN_OTP_VALIDITY_LIST }]}
                awaitRefetchQueries
                onCompleted={(e) => {
                  if (e && e.adminRevokeOtpValidity && e.adminRevokeOtpValidity.ok) {
                    setToDelete(null);
                  }
                }}
              >
                {(revoke, { loading }) => {
                  if (loading) return <PleaseWait />;
                  return (
                    <Flex justifyContent={'center'} alignItems={'center'} mt={4}>
                      <Button variant={'primary'} style={{ width: 'fit-content' }} onClick={() => setToDelete(null)}>
                        Cancel
                      </Button>
                      <Button variant={'danger'} ml={3} onClick={revoke}>
                        Delete
                      </Button>
                    </Flex>
                  );
                }}
              </Mutation>
            </Flex>
          </ModalInnerSmall>
        </ConfirmModal>
      )}
    </Container>
  );
};

export default withRouter(AdminOtpValidities);
